// CourseManagement.jsx (Supabase-powered)
import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { Link } from 'react-router-dom';

export default function CourseManagement() {
  const [courses, setCourses] = useState([]);

  const fetchCourses = async () => {
    const { data, error } = await supabase.from('courses').select('*');
    if (error) console.error('Error fetching courses:', error);
    else setCourses(data);
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const deleteCourse = async (id) => {
    if (window.confirm('Are you sure you want to delete this course?')) {
      await supabase.from('courses').delete().eq('id', id);
      fetchCourses();
    }
  };

  const toggleStatus = async (course) => {
    const newStatus = course.status === 'active' ? 'paused' : 'active';
    await supabase.from('courses').update({ status: newStatus }).eq('id', course.id);
    fetchCourses();
  };

  const toggleAI = async (course) => {
    await supabase.from('courses').update({ ai_enabled: !course.ai_enabled }).eq('id', course.id);
    fetchCourses();
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Course Management</h1>
        <Link
          to="/admin/courses/new"
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          + Add New Course
        </Link>
      </div>

      <table className="min-w-full bg-white shadow rounded-lg overflow-hidden">
        <thead className="bg-gray-200">
          <tr>
            <th className="py-2 px-4 text-left">Title</th>
            <th className="py-2 px-4 text-left">Status</th>
            <th className="py-2 px-4 text-left">AI Tutor</th>
            <th className="py-2 px-4 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <tr key={course.id} className="border-t">
              <td className="py-2 px-4">{course.title}</td>
              <td className="py-2 px-4 capitalize">{course.status}</td>
              <td className="py-2 px-4">{course.ai_enabled ? 'Enabled' : 'Disabled'}</td>
              <td className="py-2 px-4 flex flex-wrap justify-center gap-2">
                <Link
                  to={`/admin/courses/edit/${course.id}`}
                  className="bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-700"
                >
                  Edit
                </Link>
                <button
                  onClick={() => toggleStatus(course)}
                  className="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600"
                >
                  {course.status === 'active' ? 'Pause' : 'Activate'}
                </button>
                <button
                  onClick={() => toggleAI(course)}
                  className="bg-purple-600 text-white px-2 py-1 rounded hover:bg-purple-700"
                >
                  {course.ai_enabled ? 'Disable AI' : 'Enable AI'}
                </button>
                <button
                  onClick={() => deleteCourse(course.id)}
                  className="bg-red-600 text-white px-2 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
// This component manages courses, allowing admins to view, edit, delete, and toggle AI features.